<template>
  <div id="navbar" class="blue shadow">
    <div class="navbar-top d-flex justify-content-between">
      <ul class="d-none d-md-block">
        <li 
          v-for="(link, index) in topNavLinks.primary" 
          :key="'top-link-' + index" 
          class="d-inline-block"
          :class="link.bgColor"
        >
          <a 
            :class="'text-' + link.color" 
            :href="link.link" 
            :title="link.entreprise + ': ' + link.title"
          >
            {{ link.title }}
          </a>
        </li>
      </ul>

      <ul class="d-none d-md-block">
        <li 
          v-for="(link, index) in topNavLinks.secondary" 
          :key="'secondary-link-' + index" 
          class="d-inline-block mx-2"
        >
          <b-link 
            v-if="link.action"
            :title="link.title" 
            v-b-tooltip.hover 
            @click.prevent="runMethod(link.action)" 
            class="text-white"
          >
            <font-awesome-icon :icon="link.icon" size="lg" />
          </b-link>

          <b-link 
            v-else
            :title="link.title" 
            v-b-tooltip.hover 
            :to="link.link" 
            class="text-white"
          >
            <font-awesome-icon :icon="link.icon" size="lg" />
          </b-link>
        </li>
      </ul>
    </div>
     
    <div class="d-flex py-2 px-3">
      <b-navbar toggleable="md" v-if="brand">
        <b-navbar-toggle target="nav-text-collapse">
          <font-awesome-icon class="text-white" icon="bars" size="lg" />
        </b-navbar-toggle>

        <b-navbar-brand href="https://lacartoucherie.com/klix-transformation-numerique">
          <img 
            :src="brand.logo" 
            id="navbar-brand" 
            class="d-inline-block align-top navbar-img" 
            :alt="brand.org" 
          />
        </b-navbar-brand>

        <b-collapse id="nav-text-collapse" is-nav>
          <b-navbar-nav class="ml-auto mr-auto">
            <b-nav-item 
              v-for="(link, index) in mainNavLinks.primary" 
              :key="'primaryMainLink-' + index" 
              class="mx-2" 
              :to="link.link"
            >{{ link.title }}</b-nav-item>
          </b-navbar-nav>          
        
          <b-navbar-nav 
            v-for="(link, index) in topNavLinks.secondary" 
            :key="'top-link-' + index" 
            class="d-block d-md-none ml-auto pr-3"
          >
            <b-nav-item
              v-if="link.action"
              :title="link.title" 
              v-b-tooltip.hover 
              @click.prevent="runMethod(link.action)" 
              class="mx-2"
            >{{ link.title }}</b-nav-item>

            <b-nav-item
              v-else
              :title="link.title" 
              v-b-tooltip.hover 
              :to="link.href" 
              class="mx-2"
            >{{ link.title }}</b-nav-item>
          </b-navbar-nav>
          
          <b-navbar-nav class="d-block d-md-none ml-auto">
            <b-nav-item 
              v-for="(link, index) in topNavLinks.primary" 
              :key="'primaryMainLink-' + index" 
              class="mx-2" 
              variant="muted"
              :to="link.link"
            >
              <span class="text-dark-color text-smaller">
                {{ link.entreprise }}: {{ link.title }}
              </span>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Navbar',
  props: [
    'brand'
  ],
  data() {
    return {
      mainNavLinks: {
        primary: [
          {
            link: {name: 'klix', hash:'#scanning'},
            title: `Numériser`
          },
          {
            link: {name: 'klix', hash:'#managing'},
            title: `Organiser`
          },
          {
            link: {name: 'klix', hash:'#automating'},
            title: `Automatiser`
          }
        ],
        secondary: []
      },
      topNavLinks: {
        primary: [
          {
            bgColor: `white`,
            color: `black`,
            link: `https://www.lacartoucherie.com/`,
            title: `Équipement et fournitures`,
            entreprise: `La Cartoucherie`
          },
          {
            bgColor: `blue`,
            color: `white`,
            link: `https://www.lacartoucherie.com/klix-transformation-numerique`,
            title: `Transformation numérique`,
            entreprise: `KLIX`
          }/* ,
          {
            bgColor: `black`,
            color: `white`,
            link: `https://www.lacartoucherie.com/maestro-gestion-de-parc-d-impression`,
            title: `Gestion de parc d'impression`,
            entreprise: `Maestro` 
          } */
        ],
        secondary: [
          /* {
            link: `/blog`,
            title: `Blogue`,
            icon: `newspaper`
          }, */
          {
            action: `toggleModal`,
            title: `Nous joindre`,
            icon: `map-marker-alt`
          }/* ,
          {
            action: `lang`,
            title: `Préférence`,
            icon: `globe`
          } */
        ],
      }
    }
  },
  mounted() {},
  computed: {},
  methods: {
    runMethod(method){
      this[method]()
    },
    toggleModal() {
      this.$emit('toggleModal')
    },
    lang() {
      console.log('FR|EN')
    }
  }
}
</script>

<style scoped>
#navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 0;
}

.navbar {
  width: 100%;
}

.navbar-img {
  height: 35px;
}

.navbar-toggler {
  border: none;
}

.navbar-top {
  background-color: #2A2A2A;
}

  .navbar-top > ul {
    box-sizing: border-box;
    list-style-type: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .navbar-top > ul > li,
  .navbar-top > .navbar-nav > li {
    font-size: 12px;
    font-weight: bold;
    padding: 8px 16px;
  }

  .navbar-top > ul > li {
    line-height: 24px;
  }

  .navbar-nav > .nav-item > .nav-link {
    font-size: 18px;
    line-height: 24px;
    color: #fff;
    text-transform: uppercase;
    transition: color 0.3s;
  }

  .navbar-nav > .nav-item > .nav-link:hover{
      color: #bbf1ff;
  }
</style>
